import { render, staticRenderFns } from "./ReplaceDocument.vue?vue&type=template&id=42803e38&scoped=true&"
import script from "./ReplaceDocument.vue?vue&type=script&lang=js&"
export * from "./ReplaceDocument.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceDocument.vue?vue&type=style&index=0&id=42803e38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42803e38",
  null
  
)

export default component.exports